import { createSelector } from 'reselect';

import { RequestState } from '../reducers/utils/state-manager';

export type MessageTranslationState = {
  // We're going against our usual pattern by using messageId instead of
  // messageTranslationId here because knowing the messageTranslationId
  // is not a useful piece of information for how we're using translations
  // Additionally, we're using a nested map for the state which requires
  // our reducers to spread the state when updating a single language
  messageTranslationsById: Record<number, { [languageCode: string]: MessageTranslation }>;
  messageTranslationsStateByMessageId: Record<number, RequestState>;
  messageTranslationsStateByContactId: Record<number, RequestState>;
};
type State = { messageTranslations: MessageTranslationState };

const messageTranslationsByMessageIdSelector = (state: State) =>
  state.messageTranslations.messageTranslationsById;
const messageTranslationsSelector = createSelector(
  [messageTranslationsByMessageIdSelector],
  (messageTranslationsByMessageId) => messageTranslationsByMessageId,
);

export const messageTranslationForMessageIdSelector = createSelector(
  [messageTranslationsSelector, (_state: State, messageId: number) => messageId],
  (messageTranslations, messageId) => messageTranslations[messageId],
);

const messageTranslationsStateByMessageIdSelector = (state: State) =>
  state.messageTranslations.messageTranslationsStateByMessageId;
export const messageTranslationsStateForMessageIdSelector = createSelector(
  [messageTranslationsStateByMessageIdSelector, (_state: State, messageId: number) => messageId],
  (messageTranslationsStateByMessageId, messageId) =>
    messageTranslationsStateByMessageId[messageId],
);

const messageTranslationsStateByContactIdSelector = (state: State) =>
  state.messageTranslations.messageTranslationsStateByContactId;
export const messageTranslationsStateForContactIdSelector = createSelector(
  [messageTranslationsStateByContactIdSelector, (_state: State, contactId: number) => contactId],
  (messageTranslationsStateByContactId, contactId) =>
    messageTranslationsStateByContactId[contactId],
);
